<template>
  <section
    class="page-market-buy lp-payment"
    style="padding: 12px"
  >
    <div v-if="!loading">
      <b-row>
        <b-col
          class="d-flex align-items-center my-1"
          sm="12"
        >
          <h2 class="page-title">
            {{ $t('Secure payment') }}
          </h2>
        </b-col>
      </b-row>
      <div
        v-if="selectedProduct"
        class="payment-package-details"
      >
        <div class="package-left">
          <b-img
            :src="iconDiamonds3"
            width="38"
          />
        </div>
        <div class="package-right">
          <div class="package-name">
            {{ numberFormat(selectedProduct.product.credits) }}
            {{ $t('Diamonds') }}
            <span>
              | {{ selectedProduct.product.currency === 'USD' ? '$' : '&#8378;' }} {{ selectedProduct.product.amount }}
            </span>
          </div>
          <div class="package-description">
            {{ $t('By buying {count} diamonds, you will start chatting as you wish', {count: selectedProduct.product.credits}) }}
          </div>
        </div>
      </div>
      <b-row>
        <b-col
          md="12"
          sm="12"
        >
          <b-row>
            <b-col md="12">
              <h3 class="h3">
                {{ $t('Payment methods') }}
              </h3>
            </b-col>
            <b-col
              xl="12"
              lg="12"
              md="12"
            >
              <div
                class="accordion buying-options"
                role="tablist"
              >
                <div class="buying-option">
                  <div
                    v-b-toggle.accordion-1
                    class="buying-option-header"
                    role="tab"
                  >
                    <div>
                      {{ $t('Payment by credit card') }}
                    </div>
                    <div class="fs-14 color-gray fw-300">
                      {{ $t('You can pay securely with your credit card') }}
                    </div>
                    <span class="badge-advantage">
                      {{ $t('Most advantageous') }}
                    </span>
                  </div>
                  <b-collapse
                    id="accordion-1"
                    accordion="my-accordion"
                    role="tabpanel"
                    visible
                  >
                    <div class="buying-option-body">
                      <validation-observer
                        ref="formCreditCard"
                        #default="{invalid}"
                      >
                        <b-form
                          class="mt-2"
                          @submit.prevent
                        >
                          <b-row>
                            <b-col
                              md="12"
                              sm="12"
                            >
                              <b-form-group
                                label-for="cc-name"
                                :label="$t('Firstname')"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Firstname')"
                                  vid="firstname"
                                  rules="required"
                                >
                                  <b-form-input
                                    id="cc-name"
                                    v-model="creditCard.firstname"
                                    autocomplete="cc-name"
                                    name="cc-name"
                                    :placeholder="$t('Firstname')"
                                    :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              md="12"
                              sm="12"
                            >
                              <b-form-group
                                label-for="cc-lastname"
                                :label="$t('Lastname')"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Lastname')"
                                  vid="lastname"
                                  rules="required"
                                >
                                  <b-form-input
                                    id="cc-lastname"
                                    v-model="creditCard.lastname"
                                    autocomplete="cc-lastname"
                                    name="cc-lastname"
                                    :placeholder="$t('Lastname')"
                                    :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              md="12"
                              sm="12"
                            >
                              <b-form-group
                                label-for="cc-number"
                                :label="$t('Credit card number')"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Credit card number')"
                                  vid="number"
                                  rules="required|min:16"
                                >
                                  <b-form-input
                                    id="cc-number"
                                    v-model="creditCard.number"
                                    v-mask="'#### #### #### ####'"
                                    masked="false"
                                    autocomplete="cc-number"
                                    name="cc-number"
                                    type="tel"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    autocompletetype="cc-number"
                                    :placeholder="$t('Credit card number')"
                                    :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="4"
                              md="4"
                              sm="4"
                            >
                              <b-form-group
                                :label="$t('Month')"
                                label-for="month"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Month')"
                                  vid="month"
                                  rules="required"
                                >
                                  <b-form-input
                                    id="month"
                                    v-model="creditCard.month"
                                    v-mask="'##'"
                                    masked="false"
                                    autocomplete="cc-month"
                                    name="cc-month"
                                    type="tel"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    autocompletetype="cc-month"
                                    :placeholder="$t('Month')"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="4"
                              md="4"
                              sm="4"
                            >
                              <b-form-group
                                :label="$t('Year')"
                                label-for="cc-exp-year"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Year')"
                                  vid="year"
                                  rules="required"
                                >
                                  <b-form-input
                                    id="year"
                                    v-model="creditCard.year"
                                    v-mask="'##'"
                                    masked="false"
                                    autocomplete="cc-year"
                                    name="cc-year"
                                    type="tel"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    autocompletetype="cc-year"
                                    :placeholder="$t('Year')"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              cols="4"
                              md="4"
                              sm="4"
                            >
                              <b-form-group
                                label-for="cvv"
                                label="CVV2"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  name="CVV2"
                                  vid="cvv"
                                  rules="required"
                                >
                                  <b-form-input
                                    id="cvv"
                                    v-model="creditCard.cvv"
                                    v-mask="['###']"
                                    masked="false"
                                    autocomplete="cc-csc"
                                    name="cc-csc"
                                    type="tel"
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                    autocompletetype="cc-csc"
                                    placeholder="CVV2"
                                    :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              md="12"
                              sm="12"
                            >
                              <b-form-group
                                label-for="email"
                                :label="$t('Email')"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Email')"
                                  vid="email"
                                  rules="required|email"
                                >
                                  <b-form-input
                                    id="email"
                                    v-model="creditCard.email"
                                    name="email"
                                    :placeholder="$t('Email')"
                                    :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                  />
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              md="12"
                              sm="12"
                            >
                              <b-form-group
                                label-for="phone"
                                :label="$t('Phone number')"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Phone number')"
                                  vid="phone"
                                  rules="required"
                                >
                                  <vue-tel-input
                                    v-model="creditCard.phone"
                                    mode="auto"
                                    :input-options="{placeholder: $t('Phone number')}"
                                    valid-characters-only
                                    :style-classes="['phone-input']"
                                    @open="onDropdownOpen(true)"
                                    @close="onDropdownOpen(false)"
                                    @country-changed="countryChanged"
                                    @validate="phoneValidate"
                                  >
                                    <template v-slot:arrow-icon>
                                      <span class="font-small-3 mr-05">
                                        {{ country ? '+' + country.dialCode : '' }}
                                      </span>
                                      <font-awesome-icon
                                        v-if="open"
                                        icon="fa-solid fa-chevron-up"
                                      />
                                      <font-awesome-icon
                                        v-else
                                        icon="fa-solid fa-chevron-down"
                                      />
                                    </template>
                                  </vue-tel-input>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              class="mt-2"
                              xl="12"
                              lg="12"
                              md="12"
                            >
                              <b-button
                                variant="primary"
                                block
                                :disabled="loading || invalid"
                                @click="buyWithCreditCard"
                              >
                                <div class="button-secure-icon">
                                  <b-img
                                    :src="iconSecureBuying"
                                    class=""
                                    height="26"
                                  />
                                </div>
                                <span style="color: #fff !important;">
                                  {{ $t('Buy') }}
                                </span>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-form>
                      </validation-observer>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <form
      v-if="paymentData"
      ref="posnetForm"
      method="post"
      :action="posnetUrl"
    >
      <input
        id="posnetData"
        name="posnetData"
        type="hidden"
        :value="paymentData.posnetData"
      >
      <input
        id="posnetData2"
        name="posnetData2"
        type="hidden"
        :value="paymentData.posnetData2"
      >
      <input
        id="mid"
        name="mid"
        type="hidden"
        :value="paymentData.mid"
      >
      <input
        id="posnetID"
        name="posnetID"
        type="hidden"
        :value="paymentData.posnetId"
      >
      <input
        id="sign"
        name="digest"
        type="hidden"
        :value="paymentData.digest"
      >
      <input
        id="merchantReturnURL"
        name="merchantReturnURL"
        type="hidden"
        :value="callbackUrl"
      >
      <input
        id="lang"
        name="lang"
        type="hidden"
        value="tr"
      >
      <input
        id="url"
        name="url"
        type="hidden"
        :value="currentUrl"
      >
    </form>
  </section>
</template>
<script>
import {
  BButton,
  BCol,
  BCollapse,
  BForm,
  BFormGroup,
  BFormInput,
  BImg,
  BRow,
} from 'bootstrap-vue'
import {
  convertTrChars,
  numberFormat,
  throwDefaultError,
  throwPaymentError,
} from '@/helpers/helpers'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import { mask } from 'vue-the-mask'
import useJwt from '@/auth/jwt/useJwt'
import moment from 'moment'

const iconDiamonds3 = require('@/assets/images/icons/diamonds-3.svg')
const iconSecureBuying = require('@/assets/images/icons/secure-buying.svg')

const appUrl = process.env.VUE_APP_URL
const posnetUrl = process.env.VUE_APP_POSNET_URL

export default {
  name: 'LpPayment',
  directives: { mask },
  components: {
    BButton,
    BCol,
    BCollapse,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BRow,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    selectedProduct: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      callbackUrl: `${appUrl}/lps-payment-finalize`,
      country: null,
      creditCard: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        number: '',
        month: '',
        year: '',
        cvv: '',
      },
      iconDiamonds3,
      iconSecureBuying,
      monthsCreditCard: [
        'Ay',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
      open: false,
      paymentData: null,
      posnetUrl,
    }
  },
  computed: {
    currentUrl() {
      const route = this.$router.resolve({ name: 'lp1' })

      return appUrl + route?.href
    },
    yearsCreditCard() {
      const years = [
        this.$t('Year'),
      ]
      const currentYear = new Date().getFullYear()
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 10; i++) {
        years.push((currentYear + i).toString())
      }
      return years
    },
  },
  created() {
    const user = this.$store.getters['auth/user']

    if (user) {
      this.creditCard.firstname = user.firstName || ''
      this.creditCard.lastname = user.lastName || ''
      this.creditCard.phone = user.phoneNumber || ''
      this.creditCard.email = user.email || ''
    }
  },
  methods: {
    numberFormat,
    buyWithCreditCard() {
      this.$refs.formCreditCard.validate().then(success => {
        if (success) {
          this.$emit('setLoading', true)
          const data = {
            creditCard: {
              cardNumber: this.creditCard.number.replace(/\s/g, '').replace(/-/g, ''),
              expiryMonth: this.creditCard.month,
              expiryYear: this.creditCard.year,
              cardCVV: this.creditCard.cvv,
            },
            email: this.creditCard.email,
            firstName: convertTrChars(this.creditCard.firstname),
            lastName: convertTrChars(this.creditCard.lastname),
            phoneNumber: this.creditCard.phone.replace(/\s/g, ''),
            productId: this.selectedProduct.id,
          }
          useJwt.paymentPostnetInit(data)
            .then(response => {
              try {
                this.paymentData = response.data.body
                localStorage.setItem('LAST_PAYMENT_TRANSACTION_ID_KEY', this.paymentData.paymentTransactionId)
                localStorage.setItem('LAST_PAYMENT_AMOUNT', this.selectedProduct.product.amount)
                localStorage.setItem('show_auth', 'true')
                localStorage.setItem('show_auth_time', moment().add('3', 'minute').unix())

                this.$emit('lpUserAction', 'payment-attempt')

                setTimeout(() => {
                  this.$refs.posnetForm.submit()
                }, 333)
              } catch (e) {
                throwDefaultError(this.$toast)
              }
            })
            .catch(error => {
              throwPaymentError(this.$toast, error)
            })
            .finally(() => {
              this.$emit('setLoading', false)
            })
        }
      })
    },
    countryChanged(country) {
      this.country = country
    },
    onDropdownOpen(open) {
      this.open = open
    },
    phoneValidate(status) {
      this.valid = status ? status.valid : false
    },
  },
}
</script>

<style lang="scss" scoped>
input {
  padding: 16px 16px !important;
  border-radius: 12px !important;
}
</style>

<style lang="scss">
.lp-payment {
  .vs__dropdown-toggle {
    border-radius: 12px !important;
  }
}
</style>
